var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"resouce-tab"},_vm._l((_vm.tabs),function(item){return _c('li',{key:item.type + 'tabs',class:{ active: _vm.currentType === item.type },style:({ width: _vm.tabWidth }),on:{"click":function($event){return _vm.chooseTab(item)}}},[_c('span',[_vm._v("  \n      "+_vm._s(item.name)+"\n    ")])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e961b68","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/resourceTab.vue
// module id = null
// module chunks = 